module.exports = __webpack_public_path__ + "img/chokorin1.2ea0243d.png";